import type { FC, ReactNode } from 'react'
import type { PinnedStep } from '@/components/generals/pinned-steps'

import { Seo } from '@/components/generals/seo'
import { Film } from '@/components/how-it-works/film'
import { Layout } from '@/components/generals/layout'
import { PageHero } from '@/components/generals/page-hero'
import { ClosingCta } from '@/components/generals/closing-cta'
import { PinnedSteps } from '@/components/generals/pinned-steps'

import {
    HowDesignersGetScouted,
    ScoutsBehind,
    WhatWeNeverDo
} from '@/components/how-it-works/sections'

import {
    IntroWindow,
    JobBoardWindow,
    OfferWindow,
    ReviewWindow,
    ShortlistWindow,
    STEP_MOCK_NARROW_WIDTH,
    STEP_MOCK_WIDTH
} from '@/components/how-it-works/step-windows'

import { routes } from '@/constants/site'

const STEPS: PinnedStep[] = [
    {
        label: 'Role submission',
        title: 'Submit your job for review',
        body: "We only take on roles we believe we can fill. We'll tell you if we don't think yours is",
        window: <JobBoardWindow />
    },
    {
        label: 'Shortlist',
        title: 'Receive a shortlist',
        body: "You'll get a curated shortlist. Each profile accompanied with the scout's take on their work",
        window: <ShortlistWindow />
    },
    {
        label: 'Review',
        title: 'Review portfolios',
        body: 'We will ask for your feedback on each profile and improve our recommendations with every batch',
        window: <ReviewWindow />
    },
    {
        label: 'Intros',
        title: 'Introductions that are already warm',
        body: 'Once you request an intro the scout reaches out personally. The designer chooses to say yes, and we set up the first conversation',
        window: <IntroWindow />
    },
    {
        label: 'Offer',
        title: 'We stay until the offer lands',
        body: 'From first call to signed offer, we help you shape and negotiate it, and do whatever it takes to reach a yes',
        window: <OfferWindow />
    }
]

const HowItWorks: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo
                title='How it works'
                description='A quick walkthrough of what happens from the first share to offer accepted: role review, a scout-curated shortlist, warm introductions and support until the offer is signed.'
            />

            <PageHero
                variant='ambient'
                title='Find your next designer through a scout'
                sub='A quick walkthrough of what happens from the first share to offer accepted'
                primary={{ label: 'Get started', href: routes.getStarted }}
                secondary={{ label: 'See placements', href: routes.placements }}
            >
                <Film />
            </PageHero>

            <ScoutsBehind />

            <PinnedSteps
                id='five-steps'
                title='Five steps to your next hire'
                kicker='How it works'
                steps={STEPS}
                rail='right'
                mockWidth={STEP_MOCK_WIDTH}
                mockNarrowWidth={STEP_MOCK_NARROW_WIDTH}
            />

            <HowDesignersGetScouted />
            <WhatWeNeverDo />
            <ClosingCta />
        </Layout>
    )
}

export default HowItWorks
